const getGoogleClientId = function () {
  return process.env.NODE_ENV === 'production' ?
    '360716219899-r9i7vsuekq108povt1m5cprsoflqndto.apps.googleusercontent.com' :
    '360716219899-f5104e8l5b4nqr4gpbsaj1o1v1duf2dv.apps.googleusercontent.com';
};

const googleClientId = getGoogleClientId();

export default googleClientId;
